import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds, FirstAds, MobileUnderCalAds } from "../../Ads";
import { SERVER_URL, BMI_EndPoint } from "./ConstantsHealthCalculator";
import BMITable from "./BMITable";
import SharedHelmet from "../Helmet";

const TITLE = "Calculatrice IMC adulte gratuite";
const DESCRIPTION =
  "Calculez votre IMC rapidement a partir du poids et de la taille. Obtenez une interpretation simple de votre corpulence et des reperes utiles pour suivre votre evolution.";
const KEYWORDS =
  "calculatrice IMC, IMC adulte, indice de masse corporelle, calcul poids taille, interpretation IMC, poids sante";
const OG_URL = "https://do-calculate.com/calculator/fr/bmiadults/";
const apiEndpoint = `${SERVER_URL}/${BMI_EndPoint}`;

function BMICalculator() {
  const [weight, setWeight] = useState("");
  const [height, setHeight] = useState("");
  const [result, setRestul] = useState(null);
  const [error, setError] = useState(null);
  const [statusCode, setStatusCode] = useState(null);
  const [classification, setClassification] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleWeightChange = (event) => {
    setWeight(event.target.value);
  };

  const handleHeightChange = (event) => {
    setHeight(event.target.value);
  };

  const calculateBMI = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(apiEndpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ weight, height }),
      });
      const data = await response.json();
      setStatusCode(response.status);
      if (response.ok) {
        setRestul(data.result);
        setError(null);
        setClassification(data.result.classification);
      } else {
        setRestul(null);
        setError(data.error);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                L'indice de masse corporelle (IMC) est une mesure utilisée pour déterminer l'état nutritionnel des adultes. 
                Il est calculé à partir du poids d'une personne en kilogrammes, divisé par sa taille (au carré) en centimètres. 
                Les niveaux recommandés sont dérivés de la recommandation mondiale de l'Organisation mondiale de la santé 
                qui indique que la plage d'IMC normale se situe entre 18,5 et 24,9.
                <br />
                Cette calculatrice renvoie l'indice de masse corporelle et sa classification associée selon les niveaux 
                définis par l'Organisation mondiale de la santé. La calculatrice calcule l'IMC pour les hommes et les femmes.
                <br />
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-12 col-md-5 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  Indice de masse corporelle (IMC) pour les adultes
                </div>
                <hr />
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor="height" className="form-label ms-2">
                      Taille
                    </label>
                  </b>
                  <input
                    type="number"
                    id="height"
                    value={height}
                    onChange={handleHeightChange}
                    className="form-control ml-2"
                    style={{ width: "90%" }}
                    placeholder="175"
                  />
                  <div className="input-group-append">
                    <span className="input-group-text">cm</span>
                  </div>
                </div>
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor="weightNumber" className="form-label ms-2">
                      Poids
                    </label>
                  </b>
                  <input
                    type="number"
                    id="weightNumber"
                    value={weight}
                    onChange={handleWeightChange}
                    className="form-control ml-2"
                    style={{ width: "90%" }}
                    placeholder="65"
                  />
                  <div className="input-group-append">
                    <span className="input-group-text">kg</span>
                  </div>
                </div>
                <br />
                <hr />
                <div>
                  <button
                    className="btn btn-success"
                    style={{ fontSize: "20px" }}
                    onClick={calculateBMI}
                    disabled={isLoading}
                  >
                    {isLoading ? (
                      <div className="spinner-border spinner-border-sm" role="status">
                        <span className="visually-hidden">Chargement...</span>
                      </div>
                    ) : (
                      "Calculer"
                    )}
                  </button>
                </div>
              </div>
              <div className="col-12 col-md-7">
                <BMITable classification={classification}></BMITable>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
            <div className="row">
              <div className="row">
                <div className="col">
                  {statusCode === 400 && (
                    <div className="alert alert-warning">
                      <b>
                        <u>Erreur :</u>
                      </b>{" "}
                      Veuillez entrer une taille et un poids valides
                    </div>
                  )}
                  {result && (
                    <div>
                      <h4>Résultats :</h4>
                      <hr />
                      <div className="alert alert-success">
                        <label>
                          <b>Indice de masse corporelle (IMC) : </b>
                          {result.BMI.toFixed(1)} <label>kg/m²</label>
                        </label>
                      </div>
                      <div className="alert alert-success">
                        <label>
                          <b>Classification : </b> {result.classification}
                        </label>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList CalculatorsTypeId={200}></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ marginTop: "20px" }}>
        <div className="col-12 col-md-8">
  <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Conseils d'utilisation</h3></div>
              <div className="info-section-body">
                <p>Mesurez votre taille sans chaussures et pesez-vous dans des conditions stables. Pour suivre votre progression, comparez vos resultats sur plusieurs semaines plutot que sur une seule mesure.</p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Qu'est-ce que l'IMC ?</h3></div>
              <div className="info-section-body"><p>L'indice de masse corporelle (IMC) met en relation votre poids et votre taille. C'est un indicateur simple pour situer votre corpulence et suivre son evolution dans le temps. Formule: IMC = poids (kg) / taille (m) au carre.</p></div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Comment interpréter votre IMC ?</h3></div>
              <div className="info-section-body"><p>Repères adultes: moins de 18,5 = maigreur, de 18,5 à 24,9 = corpulence normale, de 25 à 29,9 = surpoids, 30 et plus = obesite. L'IMC reste un indicateur global: pour une evaluation medicale complete, tenez aussi compte de l'age, de la masse musculaire et du tour de taille.</p></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BMICalculator;
